import { getTermValue } from '../../../packages/JsonQuery';
import { IAppState } from '../../common/state';
import { getJsonQuery } from '../getJsonQuery';

export function selectIsNewbuildingListing(state: IAppState) {
  const jsonQuery = getJsonQuery(state);
  const isFromDeveloper = Boolean(getTermValue('from_developer')(jsonQuery));

  return state.isNewbuildingsOnly || isFromDeveloper;
}
